module.exports = __webpack_public_path__ + "static/img/swiper2.7c3d62a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/swiper/swiper2.png
// module id = lzP9
// module chunks = 1